export default __webpack_public_path__ + "static/media/journalist.44feb1cc.jpg";